import React, { Component } from "react";
import App from "../../App";
import { Button } from "react-bootstrap";
import Pagination from "react-js-pagination";
import { withRouter, Link } from "react-router-dom";
import "../../assets/scss/order-list.scss";
import { ToastsContainer, ToastsStore } from "react-toasts";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { getPaginatedList, getList, putData } from "../../services/baseServices";
import { getFormattedDate } from "../../helper/utils";
import Loader from 'react-loader';
import ExportCSVAsync from "../common/ExportCSVAsync";
import moment from "moment";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import ConfirmationModal from '../common/Modal'
import _ from "lodash";
import { DEBOUNCE_TIME } from "../../helper/env"
import { toast } from "react-toastify";

const headers = [
	{ label: "Transaction Id", key: "id" },
	{ label: "Distributor", key: "distributor_name" },
	{ label: "Collection Date", key: "collection_date" },
	{ label: "Amount", key: "amount" },
	{ label: "Bank", key: "bank" },
	{ label: "Chalan", key: "chalan_no" },
	{ label: "Order Count", key: "order_count" },
];

var startDate = moment().subtract(29, 'days');
var today = moment();

const loadData = (item) => {
	return {
		id: item.id,
		distributor_name: item.distributor_name,
		collection_date: getFormattedDate(item.collection_date, "DD-MM-YYYY"),
		amount: item.amount,
		bank: item.bank,
		chalan_no: item.chalan_no,
		order_count: item.order_count
	};
};

class List extends Component {
    constructor() {
        super();
        this.state = {
            collections: [],
            isLoading: true,
            activePage: 1,
            per_page: 15,
            page: 1,
            temp_params: {start_date_time: startDate.format("YYYY-MM-DD"), end_date_time: today.format("YYYY-MM-DD")},
            query_params: {start_date_time: startDate.format("YYYY-MM-DD"), end_date_time: today.format("YYYY-MM-DD")},
            isExporting: false,
            start_date_time: startDate,
            end_date_time: today,
            distributors: []
        };
    }

    getQueryParams = () => {
        let params = Object.assign(this.state.query_params, {per_page: this.state.per_page, page: this.state.page});
        return params;
    }

    getPaginatedCashCollection = (params) => {
        this.setState({...this.state, isLoading: true});
        getPaginatedList("bank_transactions", params)
            .then(res => {
                this.setState({
                    collections: res.data,
                    isLoading: false,
                    per_page: res.headers['x-per-page'],
                    total_data: res.headers['x-total'],
                }, () => {
                });
            })
            .catch(errMsg => {
                this.setState({...this.state, isLoading: false});
                console.log('Error Message: ', errMsg)
            })
    }

    componentDidMount() {
        this.getPaginatedCashCollection(this.getQueryParams());
        getList("distributors")
          .then((res) => {
            this.setState({ distributors: res });
          })
          .catch((errMsg) => {});
    }

    handleOnSearch = (e) => {
        e.preventDefault();
        const tempParam = this.state.temp_params;
        console.log(tempParam)
        this.setState({...this.state, page: 1, query_params: tempParam}, () => {
            this.getPaginatedCashCollection(this.state.temp_params);
        });
    }

    handleOnFieldChange = (e) => {
        const queryData = {...this.state.temp_params};
        queryData[e.target.name] = e.target.value;
        this.setState({temp_params: queryData}, () => {
        });
    }

    handlePageChange = (pageNumber) => {
        this.setState({page: pageNumber, activePage: pageNumber}, () => {
            this.getPaginatedCashCollection(this.getQueryParams());
        });
    }

    handleOnApply = (e, picker) => {
        this.setState({
            start_date_time: getFormattedDate(picker.startDate, ''),
            end_date_time: getFormattedDate(picker.endDate, '')
        })
        this.setState({
            temp_params: {
                ...this.state.temp_params,
                start_date_time: getFormattedDate(picker.startDate, "YYYY-MM-DD"),
                end_date_time: getFormattedDate(picker.endDate, "YYYY-MM-DD")
            }
        })
    }

    debouncedOnReceiveCollection = _.debounce((id)=>{
        this.receiveCollection(id)
    }, DEBOUNCE_TIME);

    handleWithDebounceReceiveCollection = async (id) => {
        this.debouncedOnReceiveCollection(id);
    }

    receiveCollection = (id) => {
        
        putData(`bank_transactions/receive/${id}`, {})
            .then(res => {
                if (res.status_code === 200) {
                    toast.success(res.message);
                    this.getPaginatedCashCollection(this.getQueryParams());
                }
                else {
                    toast.error(res.message);
                }
            })
            .catch((err) => toast.error(err));
    }

    render() {
        return (
            <App layout="">
                <div className="main-content">
                    <div className="page-header">
                        <h2 className="page-title">Order Wise DH Collection List</h2>
                        <div className="ml-auto d-flex">
                            <ExportCSVAsync
                                fileName={
                                    "DH-Collection-" + getFormattedDate(new Date(), "DD-MM-YYYY") + ".csv"
                                }
                                Url="bank_transactions/export"
                                headers={headers}
                                params={this.state.query_params}
                                loadData={loadData}
                                title="FC-Collection List"
                            />
                        </div>
                    </div>
                    <form className="form-inline mb-3">
                        <div className="form-group mr-3">
                            <label htmlFor="status" className="sr-only">
                                Date Range
                            </label>
                            <DateRangePicker
                                initialSettings={{
                                    startDate: this.state.start_date_time,
                                    endDate: this.state.end_date_time,
                                    maxSpan: {"months": 3},
                                    showDropdowns: true,
                                    locale: {format: "DD/MM/YYYY"},
                                    autoApply: true,
                                }}
                                onApply={(e, picker) => this.handleOnApply(e, picker)}
                            >

                                <input type="text"
                                       value={this.state.start_date_time && this.state.end_date_time ? `${getFormattedDate(this.state.start_date_time, "DD/MM/YYYY")} - ${getFormattedDate(this.state.end_date_time, "DD/MM/YYYY")}` : ''}
                                       style={{textAlign: 'left', minWidth: '150px'}}
                                       placeholder={"Select date range"}
                                       className="form-control form-control-sm"/>
                            </DateRangePicker>
                        </div>
                        <div className="form-group mr-3">
                            <label htmlFor="distributor_id" className="sr-only">
                                Distributor
                            </label>
                            <select
                                id="distributor_id"
                                name="distributor_id"
                                className="form-control form-control-sm"
                                onChange={(e) => {
                                    this.handleOnFieldChange(e);
                                }}
                            >
                            <option value="">--Select Distributor--</option>
                            {this.state.distributors?.length > 0
                                ? this.state.distributors.map((item, i) => {
                                    return (
                                    <option key={i} value={item.id}>
                                        {item.name}
                                    </option>
                                    );
                                })
                                : ""}
                            </select>
                        </div>
                        <Button
                            size="sm"
                            type={`submit`}
                            onClick={this.handleOnSearch}
                            variant="primary"
                        >
                            Filter
                        </Button>
                    </form>
                    <Loader loaded={!this.state.isLoading}>
                        <div className="card-block">
                            <div className="block-body">
                                <table className="order-table table table-striped">
                                    <thead>
                                    <tr>
                                        <th style={{width: "20px"}}>#</th>
                                        <th>FC</th>
                                        <th>Transaction Id</th>
                                        <th>Transaction Date</th>
                                        <th>Total Amount</th>
                                        <th>Bank Name</th>
                                        <th>Order Count</th>
                                        <th>Received</th>
                                        <th>Action</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.collections?.length > 0 ? (
                                        this.state.collections.map((c, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>
                                                        {(this.state.page - 1) * this.state.per_page +
                                                        index +
                                                        1}
                                                    </td>

                                                    <td>
                                                        <div className="order-item">
                                                           {c.distributor_name}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="order-item">
                                                            {c.id}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="order-item">
                                                            {getFormattedDate(c.collection_date, "DD-MM-YYYY")}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="order-item">
                                                            {c.amount}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="order-item">
                                                            {c.to_bank}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="order-item">
                                                            {c.order_count}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="order-item">
                                                            {c.is_approved? 'Yes': 'No'}
                                                        </div>
                                                    </td>
                                                    <td style={{width: "150px"}} className={"nowrap"}>
                                                        <div>
                                                            <Link
                                                                to={`/dh-collections/details/${c.id}`}
                                                                className="btn btn-sm btn-outline-secondary"
                                                            >
                                                                Details
                                                            </Link>
                                                            &emsp;
                                                            {
                                                                !c.is_approved ?
                                                                <OverlayTrigger
                                                                    key="view"
                                                                    placement="top"
                                                                    overlay={
                                                                    <Tooltip id={`tooltip-view`}>
                                                                        Receive
                                                                    </Tooltip>
                                                                    }
                                                                >
                                                                    <ConfirmationModal 
                                                                        customBtn = {true}
                                                                        btnText = "Receive"
                                                                        variant = "primary"
                                                                        title="Collection" 
                                                                        body="Are you sure to receive the collection?" 
                                                                        handleAction={() =>this.handleWithDebounceReceiveCollection(c.id)}/>
                                                                </OverlayTrigger>
                                                                :
                                                                <Button disabled size="sm">
                                                                    Receive
                                                                </Button>
                                                            }
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan={8} className="text-center">
                                                {" "}
                                                <h5>No Order Found</h5>
                                            </td>
                                        </tr>
                                    )}
                                    </tbody>
                                </table>
                            </div>
                            <div className="mt-3">
                                <Pagination
                                    itemClass="page-item"
                                    linkClass="page-link"
                                    activePage={this.state.activePage}
                                    itemsCountPerPage={this.state.per_page}
                                    totalItemsCount={this.state.total_data}
                                    pageRangeDisplayed={10}
                                    onChange={this.handlePageChange.bind(this)}
                                />
                            </div>
                        </div>

                    </Loader>
                </div>
                <ToastsContainer store={ToastsStore}/>
            </App>
        );
    }
}

export default withRouter(List);
